export interface VectorPago {
    rol: string;
    v1: string;
    v2: string;
    v3: string;
    v4: string;
    v5: string;
    v6: string;
    ult: string;
  } 
  
  export const VECTORES_PAGO = [
    'V1',
    'V2',
    'V3',
    'V4',
    'V5',
    'ULT'
  ];